// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filterStyles } from "@mcmc/Overrides/Widgets/MyLists/MyListsFilter";
import { screen } from "@mcmc/XDL/Helpers";
import { css } from "styled-components";

filterStyles.accordionStyles = {
    mergeCss: true,
    css: css`
        margin-top: 16px;
    `,
};
filterStyles.container = {};

filterStyles.headingItem = {
    width: 12,
    css: css`
        padding-bottom: 0;
    `,
};

filterStyles.heading = {
    variant: "h5",
    css: css`
        margin: 0;
    `,
};

filterStyles.datesGridItem = {
    width: [12, 12, 6, 6, 6],
};

filterStyles.datesContainer = { gap: 10 };

filterStyles.dateRangeFieldset = {
    css: css`
        border: none;
        margin: 0;
        padding: 0;
        width: 100%;
    `,
};

filterStyles.fromGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        display: block;
    `,
};

filterStyles.toGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        ${screen("lte", "xs")`padding-top:25px;`}
        display: block;
    `,
};

filterStyles.toDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

filterStyles.buttonsItem = {
    width: 12,
};

filterStyles.clearFiltersButton = {
    variant: "secondary",
    css: css`
        ${screen("lte", "xs")`
            width: 100%;
        `}
    `,
};

filterStyles.clearFilterGrid = {
    width: 12,
};

filterStyles.autocompleteGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        & > div {
            width: 100%;
        }
    `,
};
